import { buildChartOptions } from '@configurations/campaignAnalytics/visitsByDayOfWeekChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartCard } from '../ChartCard';
import { EditableChartProps } from './chartProps';

type VisitsByDayOfWeekProps = EditableChartProps;

const VisitsByDayOfWeek = (props: VisitsByDayOfWeekProps) => {
  const { report, ...chartCardProps } = props;

  if (!report) return null;

  return (
    <ChartCard
      title="Visits by Day of Week"
      description={`${props.campaignName} (${props.campaignId})`}
      report={report.visitsByDayOfWeek}
      {...chartCardProps}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={buildChartOptions(report.visitsByDayOfWeek.data)}
      />
    </ChartCard>
  );
};

export default VisitsByDayOfWeek;
